import IndividualExtrasContainer from './IndividualExtrasContainer';

export default IndividualExtrasContainer;
